import { MessageDescriptor, useIntl } from 'react-intl';

import { FocusRingVariants } from '@calm-web/design-system';

import { AuthPrompt } from '@/context/auth/AuthPromptProvider';
import { useAnalytics } from '@/hooks/analytics';
import { useComponentDidMount } from '@/hooks/utils/useComponentDidMount';

import { PartnerData } from '../shared/types';
import messages from './messages';
import {
	AccountText,
	BlueLine,
	ButtonWrapper,
	WelcomeButton,
	WelcomeSignUpButton,
	WelcomeText,
} from './styles';

type CalmAccountQuestionProps = {
	activationMessage: MessageDescriptor;
	compact?: boolean;
	onCtaClick: (mode: AuthPrompt) => void;
	partnerId: string;
	partnerName: string;
	partnerDetails: PartnerData;
};

export const CalmAccountQuestion = ({
	activationMessage,
	compact,
	onCtaClick,
	partnerId,
	partnerName,
	partnerDetails,
}: CalmAccountQuestionProps) => {
	const { formatMessage } = useIntl();
	const { logEvent } = useAnalytics();
	const { category } = partnerDetails;

	useComponentDidMount(() => {
		logEvent({
			eventName: 'Welcome : Landed',
			eventProps: {
				partner_id: partnerId,
				...(category && { partner_type: [category.toLowerCase()] }),
			},
		});
	});

	return (
		<>
			<WelcomeText compact={compact}>
				{formatMessage(activationMessage, {
					partnerName,
					breakingLine: <br />,
				})}
			</WelcomeText>
			<BlueLine />
			<AccountText>{formatMessage(messages.freeAccount)}</AccountText>
			<ButtonWrapper>
				<WelcomeButton
					onPress={(): void => onCtaClick('login')}
					data-testid="b2b-login"
					focusRingVariant={FocusRingVariants.Dark}
				>
					{formatMessage(messages.logIn)}
				</WelcomeButton>
				<WelcomeSignUpButton
					fullWidth
					backgroundColor="gradientCalmBrand"
					textColor="white"
					onPress={(): void => onCtaClick('signup')}
					data-testid="b2b-signup"
					focusRingVariant={FocusRingVariants.Dark}
					contentAlignment="left"
				>
					{formatMessage(messages.signUpFree)}
				</WelcomeSignUpButton>
			</ButtonWrapper>
		</>
	);
};
